import React from 'react'
import PropTypes from 'prop-types'
import shallowCompare from 'react-addons-shallow-compare'
import {Table, Column, Cell} from 'components/Table'
import classnames from 'classnames'
import ChannelIcon from 'components/ChannelIcon'
import Select from 'components/Select'
import * as _ from 'lodash'
import NumberFormat from 'components/NumberFormat'
import {channelTypes} from '@divvit/common-channels'

export default class AggChanelsTable extends React.Component {
  static propTypes = {
    aggrStats: PropTypes.object,
    data: PropTypes.array,
    loading: PropTypes.bool,
    selectedTouchpoints: PropTypes.object,
    filters: PropTypes.object,
    limitedIds: PropTypes.array
  }

  // eslint-disable-next-line react/sort-comp
  metrics = [
    {
      name: 'Data Driven (PV)',
      value: 'order:count-non-direct-touch'
    },
    {
      name: 'Data Driven (PC)',
      value: 'order:count-non-direct-clicks'
    },
    {
      name: 'Last Touch (Non Direct)',
      value: 'order:count-non-direct-last-touch'
    },
    {
      name: 'Last Click (Non Direct)',
      value: 'order:count-non-direct-last-click'
    }
  ]

  constructor(props) {
    super(props)
    this.state = {
      hoveredGroup: null,
      selectedMetric: 'order:count-non-direct-touch'
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const touchpointsChanged =
      this.props.selectedTouchpoints === nextProps.selectedTouchpoints
    const filtersChanged = this.props.filters === nextProps.filters
    this._shouldRowUpdate = touchpointsChanged || filtersChanged
    return shallowCompare(this, nextProps, nextState)
  }

  onMetricChange = item => {
    this.setState({selectedMetric: item.value})
  }

  render() {
    const {aggrStats, data, loading, limitedIds} = this.props
    const {selectedMetric} = this.state

    const isHasChannelType = !!_.find(data, ({items}) => {
      return !!_.find(items, ({dimensions}) => {
        return !!dimensions.channelType
      })
    })

    const classNames = classnames('orders-table_shadow', {
      'with-limitation': limitedIds
    })

    return (
      <div className={classNames}>
        <div className='order-touched_header'>
          <div className='order-touched_header_title'>Conversions</div>
          <Select
            className='order-touched_select'
            value={selectedMetric}
            options={this.metrics}
            onSelect={this.onMetricChange}
          />
        </div>
        <Table
          className='orders-table'
          data={data}
          empty='No conversions could be found for the selected filters or time period.'
          loading={loading}
          onRowOver={this.onRowOver}
          onRowOut={this.onRowOut}
          shouldRowUpdate={() => this._shouldRowUpdate}
          loadingRows={30}
          hover
        >
          <Column
            header='Channel'
            cell={col => (
              <Cell>
                <div className='channelGroup'>
                  {col.channelGroup}
                </div>
                <div className='channelItem'>
                  <ChannelIcon
                    name={col.channel}
                    group={col.channelGroup}
                    active
                  />
                  <div className='channelName'>{col.channel}</div>
                </div>
              </Cell>
            )}
            width='15%'
          />
          {isHasChannelType && <Column
            header={<Cell align='center'>Channel Type</Cell>}
            cell={({items}) => (
              <Cell align='center' className='pd-0'>
                {
                  items.map(item => {
                    let channelType = channelTypes[item.dimensions.channelType].label || item.dimensions.channelType
                    return <div className='cell-content channel-type-label'>{channelType}</div>
                  })
                }
              </Cell>
            )}
            width='15%'
          />}
          <Column
            header={<Cell align='center'>Conversions touched</Cell>}
            cell={({items}) => (
              <Cell align='right' className='pd-0'>
                <div className='flex-group'>
                <div className={classnames('item', {hiden: items.length < 2})}>
                  {
                    items.map(item => <div className='cell-content'>{item['order:count']}</div>)
                  }
                  </div>
                  <div className='item item-total'>
                    {_.sumBy(items, 'order:count')}
                  </div>
                </div>
              </Cell>
            )}
            width='15%'
          />
          <Column
            header={<Cell align='center'>Touchpoints before conversion</Cell>}
            cell={({items}) => (
              <Cell align='right' className='pd-0'>
                <div className='flex-group'>
                <div className={classnames('item', {hiden: items.length < 2})}>
                  {
                    items.map(item => <div className='cell-content'>{item['session:count']}</div>)
                  }
                  </div>
                  <div className='item item-total'>
                    {_.sumBy(items, 'session:count')}
                  </div>
                </div>
              </Cell>
            )}
            width='15%'
          />
         <Column
            header={<Cell align='center'>Total Attributed Conversions</Cell>}
            cell={({items}) => (
              <Cell align='right' className='pd-0'>
              <div className='flex-group'>
              <div className={classnames('item', {hiden: items.length < 2})}>
                {
                  items.map(item => <div className='cell-content'>
                    <NumberFormat
                      value={item[selectedMetric]}
                      format={'decimalDouble'}
                    />
                  </div>)
                }
                </div>
                <div className='item item-total'>
                  <NumberFormat
                    value={_.sumBy(items, selectedMetric)}
                    format={'decimalDouble'}
                  />
                </div>
              </div>
            </Cell>
            )}
            width='15%'
          />
          <Column
            header={
              <Cell align='center'>% Of Attributed Conversions Touched</Cell>
            }
            cell={({items}) => (
              <Cell align='right' className='pd-0'>
              <div className='flex-group'>
                <div className={classnames('item', {hiden: items.length < 2})}>
                {
                  items.map(item => <div className='cell-content'>
                    {this.renderPercentTableRow(item[selectedMetric], aggrStats.filtered, 'percent')}
                  </div>)
                }
                </div>
                <div className='item item-total'>
                  {this.renderPercentTableRow(_.sumBy(items, selectedMetric), aggrStats.filtered, 'percent')}
                </div>
              </div>
            </Cell>
            )}

            width='20%'
          />
        </Table>
      </div>
    )
  }

  renderPercentTableRow(value, total, format) {
    return (
      <NumberFormat format={format} value={value !== 0 && total !== 0 ? value / total : '0'}/>
    )
  }

  onRowOver = data => {
    this.setState({
      selectedOrderId: data.id
    })
  }

  onRowOut = () => {
    this.setState({selectedOrderId: null})
  }
}



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggChanelsTable.js